<template>
  <div>
    <div class="login-box">
      <div class="login-container">
        <div>
          <div class="download-box">
            <h3>{{ $t("yhyapp") }}</h3>
            <div class="erweima-list">
              <div class="erweima-item">
                <div class="default-erweima" v-if="!Android_code"></div>
                <img :src="$host.file + Android_code" alt="loading" v-else />
                <p>android</p>
              </div>
              <div class="erweima-item">
                <div class="default-erweima" v-if="!ios_code"></div>
                <img :src="$host.file + ios_code" alt="loading" v-else />
                <p>ios</p>
              </div>
            </div>
          </div>
          <el-form
            :model="ruleForm2"
            :rules="rules2"
            ref="formName"
            label-position="left"
            label-width="0px"
            class="demo-ruleForm login-ruleForm"
            style="width: 400px;"
          >
            <div
              style="
                padding: 15px 40px;
                color: rgb(255, 255, 255);
                top: -48px;
                left: 0px;
                width: 100%;
                position: absolute;
                background: rgb(89, 172, 237);
              "
            >
              <!-- <img src="../assets/images/u11.png" style="width:180px;" alt="">
              <h3 class="title" style="text-align:left;margin-bottom:25px;">{{$t('login_title')}}</h3>-->
              <h3>
                {{ $t("user_Index_YONGHU") }}/{{ $t("user_Index_YHY") }}
                {{ $t("login") }}
              </h3>
            </div>
            <div class="login_class_header">
              <div class="login_class" :class="login_by_pwd ? 'active' : ''" @click="login_by_pwd = 1">
                {{$t('login_by_pwd')}}
              </div>
              <div class="login_class" :class="login_by_pwd ? '' : 'active'" @click="login_by_pwd = 0">
                {{$t('login_by_code')}}
              </div>
            </div>
            <!-- 密码登录 -->
            <div class="" v-if="login_by_pwd">
              <el-form-item prop="email">
                <el-input
                  type="text"
                  v-model="ruleForm2.email"
                  autocomplete="new-password"
                  prefix-icon="el-icon-user"
                  :placeholder="$t('login_tip_yx')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  type="password"
                  v-model="ruleForm2.password"
                  @keyup.enter.native="handleSubmit2()"
                  show-password
                  autocomplete="new-password"
                  prefix-icon="el-icon-lock"
                  :placeholder="$t('login_tip_mm')"
                ></el-input>
              </el-form-item>
              <div>
                <el-checkbox v-model="checked" class="remember">
                  {{$t("login_no_JZMM")}}
                </el-checkbox>
                <span style="color: #508dda; cursor: pointer" class="pull-right"
                  @click="$router.push({path: '/index/register',query: {type: 'findPsw',account: ruleForm2.email}})">
                  {{ $t("login_no_ZHMM") }}
                </span>
              </div>
            </div>
            <!-- 验证码登录 -->
            <div class="" v-else>
              <el-form-item prop="email">
                <el-input
                  type="text"
                  v-model="ruleForm2.email"
                  autocomplete="new-password"
                  prefix-icon="el-icon-user"
                  :placeholder="$t('login_tip_yx')"
                ></el-input>
              </el-form-item>
              <div style="display: flex; justify-content: space-between;">
                <el-form-item prop="code">
                  <el-input type="text"
                   @input="handleInputNum"
                   v-model="ruleForm2.code"
                   prefix-icon="el-icon-key" :placeholder="$t('enterCode')"></el-input>
                </el-form-item>
                <!-- <el-button type="primary" style="height: 40px; margin-left: 20px; width: 130px;">{{$t('code')}}</el-button> -->
                <el-button type="primary" style="height: 40px; margin-left: 20px; width: 130px;"
                :disabled="codeSending" @click="send_code">
                <template>{{code_btn_str}}</template>
                </el-button>
              </div>
              <div>
                <!-- <el-checkbox v-model="checked" class="remember">{{
                  $t("login_no_JZMM")
                }}</el-checkbox>
                <span style="color: #508dda; cursor: pointer" class="pull-right"
                  @click="$router.push({path: '/index/register', query: {type: 'findPsw', account: ruleForm2.email}})"
                  >{{ $t("login_no_ZHMM") }}</span
                > -->
              </div>
            </div>
            <!-- <el-form-item style="width:100%;"> -->
            <el-button class="login_btn" @click.native.prevent="handleSubmit2" :loading="logining">{{ $t("login") }}</el-button>

            <div class="showRegister">
              <!-- <span class="pull-left" style="color:#fa7202;cursor:pointer;" @click="$router.push('/index/index')">去首页</span> -->
            </div>
            <div class="mdl_add_order" @click="$router.push('/index/visitOrder')">
              {{ $t("免注册下单") }}
            </div>
            <!-- </el-form-item> -->
            <div style="text-align: center">
              <span style="color: #737373">
                {{ $t("login_no_account") }}
                <span style="color: #fa7202; cursor: pointer" @click="$router.push('/index/register')">
                  {{ $t("login_ljzc") }}
                </span>
              </span>
              <!--手机端-->
              <!-- <template v-if="$flag"> </template>
              <template v-else>
                <el-divider content-position="center">{{
                  $t("login_no_DSF")
                }}</el-divider>
                <div style="margin-top: 30px">
                  <img
                    style="width: 40px; margin: 0 12px; cursor: pointer"
                    src="../assets/images/QQ1.png"
                    alt
                  />
                  <img
                    style="width: 40px; margin: 0 12px; cursor: pointer"
                    src="../assets/images/weibo.png"
                    alt
                  />
                  <img
                    style="width: 40px; margin: 0 12px; cursor: pointer"
                    src="../assets/images/weixin.png"
                    alt
                  />
                  <img
                    style="width: 40px; margin: 0 12px; cursor: pointer"
                    src="../assets/images/face.png"
                    alt
                  />
                  <img
                    style="width: 40px; margin: 0 12px; cursor: pointer"
                    src="../assets/images/tiwtter.png"
                    alt
                  />
                </div>
              </template> -->
            </div>
            <!-- <div style="border-right:1px solid #eee;height:300px;width:2px;float:left;margin: 40px 100px;">

            </div>-->
          </el-form>
        </div>
        <el-dialog
          v-dialogDrag
          title="角色选择"
          v-if="centerDialogVisible"
          :visible.sync="centerDialogVisible"
          :close-on-click-modal="false"
          :modal-append-to-body="false"
          width="30%"
          center
        >
          <span>请选择您要注册的角色？</span>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveRole(1)">用 户</el-button>
            <el-button type="primary" @click="saveRole(2)">验货员</el-button>
          </span>
        </el-dialog>
      </div>

    </div>
    <footer>
      
      <p>Copyright@2006-2021 <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备14032340号</a></p>
    </footer>
  </div>
</template>
<script>
// import Login from '../api/login'

import { login, getInfo, getAccountCode } from "@/api/login.js";
import { service } from "@/api/login.js";
import cookie from "js-cookie";
import { Loading } from "element-ui";
import CryptoJS from 'crypto-js'
// import aes from "@/plugins/aes"; //加密解密文
export default {
  data() {
    return {
      Android_code: "",
      ios_code: "",
      centerDialogVisible: false,
      logining: false,
      ruleForm2: {
        email: "",
        password: "",
        code: "",
      },
      codeUrl: "",
      rules2: {
        email: [
          {
            required: true,
            message: this.$t("login_tip_yx"),
            trigger: "blur",
          },
          // {
          //   type: "email",
          //   message: this.$t("user_Index_EMAILGS"),
          //   trigger: ["blur", "change"],
          // },
        ],
        password: [
          { required: true, message: this.$t("login_tip_mm"), trigger: "blur" },
        ],
        // code: [
        //   { required: true, message: this.$t("enterCode"), trigger: "blur" },
        // ]
      },
      checked: false,
      activeName: 1,
      loadingInstance: null,
      login_by_pwd: 1, // 0:验证码登录 1:密码登录
      codeSending: 0, // 验证码是否发送 0未发生 1已发送
      code_btn_str: this.$t('code'), //验证码发送按钮文字
      code_timer: null, // 验证码发送计时器
    };
  },
  created() {
    if (this.$route.query.code) {
      //code码存在即是分享的链接，需要携带code一起注册
      this.centerDialogVisible = true;
    }

    const _this = this
    this.$store.dispatch('global/getCustomer').then(() => {
      _this.Android_code = _this.$store.state.global.KefuInfo.Android_code;
      _this.ios_code = _this.$store.state.global.KefuInfo.ios_code;
    });
  },
  methods: {
    async send_code(){
      if(this.login_by_pwd == 1 || this.codeSending == 1){
        // 密码登录则跳过
        return false
      }
      let check = 0
      this.$refs.formName.validate((valid) => {
        if (!valid) {
          check++
          return false;
        }
      });
      
      if(check) return false
      let type = this.$check.isEmail(this.ruleForm2.email) ? 'email' : 'phone'
      let limit = 60 // 60秒内不能重复发送
      this.codeSending = 1
      let params = {
        type: type,
        account: this.ruleForm2.email
      }
      const res = await getAccountCode(params)
      const {code, msg} = res.data
      if(code != 200) {
        this.codeSending = 0
        return false
      }
      let that = this
      this.code_timer = setInterval(function(){
        limit--
        if(limit>0){
          that.code_btn_str = that.$t('is_sending')+'('+limit+'S)';
        }else{
          that.codeSending = 0
          that.code_btn_str = that.$t('code');
          clearInterval(that.code_timer);
        }
      },1000);
      
    },
    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie = "userPwdManage" + "=" + c_pwd +  ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie = "userNameManage" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
    },
    //读取cookie
    getCookie() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值

          if (arr2[0] == "userNameManage") {
            this.ruleForm2.email = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "userPwdManage") {
            this.ruleForm2.password = arr2[1];
            if (arr2[1]) {
              this.checked = true;
            } else {
              this.checked = false;
            }
          }
        }
      } else {
        this.ruleForm2.email = "";
        this.ruleForm2.password = "";
      }
    },
    //清除cookie
    clearCookie(c_name, c_pwd) {
      this.setCookie(c_name, c_pwd, 7); //修改2值都为空，天数为负1天就好了
    },
    //切换角色
    TabClick(val) {
      //使用账户类型 1用户 2验货员
      localStorage.setItem("role", val.name);
      // this.amount_type = val.name
    },
    saveRole(type) {
      localStorage.setItem("role", type);

      if (this.$route.query.code) {
        this.$router.push({
          path: "/index/register",
          query: {
            code: this.$route.query.code,
          },
        });
      } else {
        this.$router.push("/index/register");
      }
      this.$router.push({
        path: "/index/register",
        query: {
          code: this.$route.query.code,
        },
      });
      this.centerDialogVisible = false;
    },
    handleInputNum(){
      this.ruleForm2.code = this.ruleForm2.code.replace(/[^0-9]/g, '');
    },
    async handleSubmit2() {
      let handleLogin = false;
      this.$refs["formName"].validate((valid) => {
        if (valid) {
          //发布公告
          handleLogin = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      if (handleLogin) {
        let user_code = null;
        let res = null;
        try {
          user_code = this.$route.query.code;
        } catch (e) {}

        this.loadingInstance = Loading.service({
          target: ".login-ruleForm",
          background: "rgb(255 255 255 / 30%)",
        });
        let params = {...this.ruleForm2}
        if (user_code) {
          params.to_uid = user_code
        } else if (this.$route.query.email || this.$route.query.tk) {
          //免登陆
          params.no_landing = 1
          res = await login({ ...this.ruleForm2, no_landing: 1 });
        }
        res = await login(params);

        if(res.data.code != 200){
          return this.loadingInstance.close();
        }

        let data = res.data.data;
        // console.log('login', data);

        localStorage.setItem("USERToken", data.data.token);
        // console.log(data.data.im_token, "===im_token===");
        cookie.set("im_chat_token", data.data.im_token);
        localStorage.setItem("im_token", data.data.im_token);
        cookie.set("auto_token", data.data.token);
        
        // let expires = new Date(
        //         new Date().getTime() + 24 * 60 * 60 * 1000
        //     ).toUTCString();
        // window.document.cookie = "imtoken="+res.data.data.data.im_token+"path=/;SameSite=None;expires="+expires;
        const resUser = await getInfo();

        if(resUser.data.code != 200){
          return '';
        }

        data = resUser.data.data;

        // console.log('getInfo', data);
        

        localStorage.setItem("loginTime", Date.now());
        localStorage.setItem("userInfo", JSON.stringify(data.data));
        // 10-9 修改默认语言
        // localStorage.setItem("locale", "zh");

        this.$store.commit("global/set_userInfo", data.data);
        // setTimeout(()=>{
        // console.log(data.data.role);
        localStorage.setItem("role", data.data.role);
        this.loadingInstance.close();
        // this.$router.push("/user");
        // this.$router.push(
        //   data.data.role == 1
        //     ? "/user"
        //     : data.data.role == 2
        //     ? "/insp"
        //     : "/user"
        // );
        // },1000)
        // 是否记住密码
        if (this.checked) {
          let user = {
            ...this.ruleForm2,
          };
          localStorage.setItem("loginInfo", JSON.stringify(user));
          //传入账号名，密码，和保存天数3个参数
          this.setCookie(this.ruleForm2.email, this.ruleForm2.password, 7);
        } else {
          this.clearCookie(this.ruleForm2.email, "");
          // localStorage.setItem('loginInfo', JSON.stringify({
          //   email: this.ruleForm2.email,
          //   password: ''
          // }))
        }
        if(this.$route.query.u){
          location.href = decodeURIComponent(this.$route.query.u)
        }else{
          this.$router.push("/user");
        }
      }
    },
  },
  mounted() {
    this.activeName = localStorage.getItem("role");
    // let user = JSON.parse(localStorage.getItem("loginInfo"));
    this.getCookie();
    // this.ruleForm2 = user || {email:'',password:''}
    if (this.$route.query.email) {
      this.ruleForm2.email = this.$route.query.email;
      this.ruleForm2.password = this.$route.query.password;
      this.handleSubmit2();
    }else if(this.$route.query.tk){
      let parsedWordArray = CryptoJS.enc.Base64.parse(this.$route.query.tk.slice(0, -4));
      const params = new URLSearchParams(decodeURIComponent(parsedWordArray.toString(CryptoJS.enc.Utf8)))
      const allParams = {};
      for (const [key, value] of params.entries()) {
          allParams[key] = value;
      }
      if(allParams.email && allParams.password){
        this.ruleForm2.email = allParams.email;
        this.ruleForm2.password = allParams.password;
        this.handleSubmit2();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
/* 小屏幕的样式*/
@media screen and (max-width: 720px) {
  .download-box {
    display: none;
  }

  .demo-ruleForm {
    float: left;
    margin: 80px 2%;
    padding: 10px 10px;
    background: rgb(225, 237, 253);
    font-size: 14px;
    position: relative;
  }

  .login-container {
    width: 100%;
  }
}

/* 大屏幕的样式*/
@media screen and (min-width: 721px) {
  .download-box {
    display: block;
  }

  .demo-ruleForm {
    margin: 120px 0px 80px;
    float: right;
    padding: 30px 36px;
    background: rgb(225, 237, 253);
    font-size: 14px;
    position: relative;
  }
}

.login-container {
  width: 1200px;
  height: calc(100vh - 200px);
  margin: 0 auto;

  .download-box {
    float: left;
    margin: 120px 0 0 120px;
    height: 400px;

    h3 {
      color: #fff;
      font-size: 36px;
      text-align: center;
      font-weight: 500;
    }

    .erweima-list {
      margin-top: 30px;
      display: table;
      width: 100%;

      .erweima-item {
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        &:first-child {
          padding-right: 30px;
        }

        .default-erweima {
          width: 210px;
          height: 210px;
          background-color: #eee;
        }

        img {
          display: inline-block;
          width: 210px;
          height: 210px;
        }

        p {
          color: #fff;
          font-size: 30px;
          margin-top: 16px;
          font-weight: 500;
        }
      }
    }
  }

  .title {
    text-align: left;
    margin-bottom: 25px;
    display: inline-block;
    border-left: 2px solid #fa7202;
    padding-left: 6px;
    margin-left: 6px;
  }

  .remember {
    margin: 0px 0px 35px 0px;
  }
}

.login-box {
  width: 100%;
  height: 100%;
  min-height: 600px;
  //   background: url(../../static/loginBg.png) no-repeat center;
  background-size: 100% 100%;
  background: url("../assets/images/login-bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.login_class_header{
  display: flex;
  margin-bottom: 20px;
  justify-content: center;
}
.login_class{
  padding: 5px 10px;
  margin: 0 30px;
  cursor: pointer;
}
.login_class.active{
  border-bottom: 2px solid #59aced;
  color: #59aced;
  cursor: default;
}

.login_btn{
  width: 100%;
  height: 54px;
  font-size: 16px;
  border-radius: 5px;
  background: #508dda;
  color: #fff;
  margin-bottom: 15px;
}

.showRegister {
  font-size: 12px;
  // text-align: center;
  margin-top: 14px;
  overflow: hidden;
}

.login-left {
  width: 544px;
  height: 608px;
  background: #eaeaea;
  /* position: absolute; */
  vertical-align: top;
  display: inline-block;
}

.login-right {
  padding: 100px;
  background: #fff;
  display: inline-block;
  width: 564px;
  height: 606px;
}

/deep/ .el-form-item--small.el-form-item {
  margin-bottom: 30px;
}

/deep/ .el-input--small .el-input__inner {
  height: 42px;
  line-height: 32px;
}

/deep/ .el-divider__text {
  background-color: transparent;
  color: #737373;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #508edb;
  border-color: #508edb;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #508edb;
}

.mdl_add_order {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  background: rgb(247, 103, 102);
  cursor: pointer;
  color: #fff;
  height: 54px;
  line-height: 54px;
  border-radius: 4px;
}

footer {
  margin-top: 60px;
  display: flex;
  justify-content: center;
  background: #ffffff;
  height: 77px;
  line-height: 77px;
  font-size: 16px;
  color: #CACACA;
  // border-top: 1px solid #efefef;
}
</style>
